import script from "./RechargeReminder.vue?vue&type=script&setup=true&lang=ts&MinusCircleOutlined=true&name=RechargeReminder"
export * from "./RechargeReminder.vue?vue&type=script&setup=true&lang=ts&MinusCircleOutlined=true&name=RechargeReminder"

import "./RechargeReminder.vue?vue&type=style&index=0&id=c8b8d102&lang=scss&scope=true"

const __exports__ = script;

export default __exports__